// Beneficiary segmentation — FY 2024-25

export const BENEFICIARY_TYPES = [
  { type: "Youth",      value: 7200,  gender: { female: 2304, male: 4896 }, pillar: "employability",    color: "#3B82F6" },
  { type: "Farmers",    value: 9800,  gender: { female: 4900, male: 4900 }, pillar: "entrepreneurship", color: "#F59E0B" },
  { type: "Women SHGs", value: 4200,  gender: { female: 4200, male: 0    }, pillar: "entrepreneurship", color: "#EC4899" },
  { type: "Artisans",   value: 4300,  gender: { female: 2580, male: 1720 }, pillar: "entrepreneurship", color: "#A855F7" },
  { type: "MSME owners",value: 520,   gender: { female: 130,  male: 390  }, pillar: "environment",      color: "#10B981" },
];

export const RURAL_URBAN_SPLIT = { rural: 82, urban: 18 };

export const AGE_BANDS = [
  { band: "18–24", value: 38, label: "Young adults",   description: "Skilling-age youth, first-time job seekers",        icon: "GraduationCap", color: "#3B82F6" },
  { band: "25–35", value: 41, label: "Working adults", description: "Early-career professionals & emerging entrepreneurs", icon: "Briefcase",     color: "#F59E0B" },
  { band: "36–45", value: 14, label: "Mid-career",     description: "Established earners, SHG leaders & farmers",        icon: "Users",         color: "#10B981" },
  { band: "46+",   value: 7,  label: "Senior",         description: "Master artisans, MSME owners, community elders",    icon: "Heart",         color: "#A855F7" },
];
